module.exports = __webpack_public_path__ + "static/img/img.dd03fa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img.jpg
// module id = Rx1w
// module chunks = 17